/**
 * Valor de metadata (identificador interno) pronto para exibir.
 *
 * A API aceita metadata com valores aninhados (objeto ou lista). Renderizar o
 * valor cru derrubava a tela inteira ("Objects are not valid as a React child"),
 * como no detalhe da recorrência do checkout SaaS (SC-11070, Sentry CONTA-Z).
 */
export const formatMetadataValue = (value: unknown): string => {
  if (value === null || value === undefined) return ''
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}
